import { isExpressShipment } from 'pages/NewCart/helpers/shipment.helper';
import { INewCartShipment } from 'pages/NewCart/ICart';

// For Order level min checkout value handling
export const minimumMovMetOrderLevel = (
  minOrderThreshold: number | undefined,
  isNowUnavailableHour: boolean | undefined,
  shipments: INewCartShipment[] | undefined,
  cartTotal: number,
  currency: string,
  t: any
): { showNotification: boolean; message: string; thresholdPercentage: number | null } => {
  let showNotification;
  let message;
  let thresholdPercentage = null;

  // if order level threshold is not configured we need to check for all the shipments mov
  if (minOrderThreshold === undefined) {
    let movShipmentLevelNotMet = false;
    // if there is offlinehour we need to exclude express shipment from shipment mov check
    if (isNowUnavailableHour) {
      movShipmentLevelNotMet =
        !!shipments &&
        !!shipments
          .filter((sm: INewCartShipment) => !isExpressShipment(sm.shipmentType))
          .find((sm: INewCartShipment) => !sm.movMet);
    } else if (shipments && shipments.length === 1) {
      return minimumMovMetShipmentLevel(shipments[0], t);
    } else {
      // mov for all the shipment level should be met
      movShipmentLevelNotMet =
        !!shipments && !!shipments.find((sm: INewCartShipment) => !sm.movMet);
    }
    showNotification = movShipmentLevelNotMet;
    message = t('minThresholdOrderForShipment');
  } else {
    // Order level Mov Met or not, if configured on backend
    showNotification = minOrderThreshold > cartTotal;
    message = t('minThresholdOrder', {
      minThreshold: minOrderThreshold ? minOrderThreshold.toFixed(2) : '',
      currency,
    });

    thresholdPercentage = calculateThresholdPercentage(cartTotal, minOrderThreshold);
  }
  return { showNotification, message, thresholdPercentage };
};

// For Shipment level min checkout value handling
export const minimumMovMetShipmentLevel = (shipment: INewCartShipment, t: any) => {
  let showNotification = false;
  let message = '';
  showNotification = shipment ? !shipment.movMet : false;
  message = t('minThresholdShipment', {
    minThreshold: shipment && shipment.minThreshold ? shipment.minThreshold.toFixed(2) : 0,
    currency: shipment ? shipment.subTotal.currencyIso : '',
  });

  const thresholdPercentage = calculateThresholdPercentage(
    shipment.subTotal.value,
    shipment.minThreshold
  );

  return { showNotification, message, thresholdPercentage };
};

export const calculateThresholdPercentage = (
  amount: number,
  thresholdAmount?: number
): number | null => {
  if (!thresholdAmount) {
    return null;
  }

  return Math.floor((amount / thresholdAmount) * 100);
};
